import "src/lib/sentry";
import "src/lib/datadog";

import { createRoot } from "react-dom/client";
// biome-ignore lint/style/noRestrictedImports: legacy suppression
import { wrapCreateBrowserRouter } from "@sentry/react";
import { createBrowserRouter as createDatadogBrowserRouter } from "@datadog/browser-rum-react/react-router-v6";
// biome-ignore lint/style/noRestrictedImports: legacy suppression
import { RouterProvider } from "react-router-dom";

import { installChunkLoadErrorHandler } from "src/lib/chunk-reload";
import { filterConsoleErrors } from "src/utils/logs";
import { routes } from "./components/router";
import { RootProviders } from "./components/app/providers";

installChunkLoadErrorHandler();

const root = createRoot(document.getElementById("react")!);

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(
  createDatadogBrowserRouter,
);
const router = sentryCreateBrowserRouter(routes);

filterConsoleErrors();

root.render(
  <RootProviders>
    <RouterProvider router={router} fallbackElement={null} />
  </RootProviders>,
);
